"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _default = {
    v: "5.7.3",
    fr: 60,
    ip: 2,
    op: 180,
    w: 720,
    h: 720,
    nm: "Scriber S Paper 3",
    ddd: 0,
    assets: [
        {
            id: "comp_0",
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: "Vector 5",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                554.282,
                                340.304,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    ind: 0,
                                    ty: "sh",
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    40.328,
                                                    -33.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -33.84,
                                                    -40.337
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    37.803,
                                                    130.304
                                                ],
                                                [
                                                    102.58,
                                                    75.939
                                                ],
                                                [
                                                    183.773,
                                                    7.796
                                                ],
                                                [
                                                    96.491,
                                                    -96.245
                                                ],
                                                [
                                                    -37.803,
                                                    -107.996
                                                ],
                                                [
                                                    -183.773,
                                                    14.512
                                                ]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: "Path 1",
                                    mn: "ADBE Vector Shape - Group",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.023529411764705882,
                                            0.4196078431372549,
                                            0.39215686274509803,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 60,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Vector",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 0,
                                k: 0,
                                ix: 1
                            },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.48
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.26
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        t: 35,
                                        s: [
                                            100
                                        ]
                                    },
                                    {
                                        t: 67,
                                        s: [
                                            0
                                        ]
                                    }
                                ],
                                ix: 2
                            },
                            o: {
                                a: 0,
                                k: 0,
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 1775,
                    st: -25,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 4,
                    nm: "Vector",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                446.042,
                                601.254,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    ind: 0,
                                    ty: "sh",
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -40.328,
                                                    33.846
                                                ],
                                                [
                                                    33.84,
                                                    40.337
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -40.328,
                                                    33.846
                                                ],
                                                [
                                                    -33.84,
                                                    -40.337
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    33.84,
                                                    40.337
                                                ],
                                                [
                                                    40.328,
                                                    -33.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -33.84,
                                                    -40.337
                                                ],
                                                [
                                                    40.328,
                                                    -33.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -146.042,
                                                    114.492
                                                ],
                                                [
                                                    -45.208,
                                                    234.686
                                                ],
                                                [
                                                    89.086,
                                                    246.438
                                                ],
                                                [
                                                    100.835,
                                                    112.118
                                                ],
                                                [
                                                    0,
                                                    -8.077
                                                ],
                                                [
                                                    -87.283,
                                                    -112.118
                                                ],
                                                [
                                                    -75.534,
                                                    -246.438
                                                ],
                                                [
                                                    58.759,
                                                    -234.686
                                                ],
                                                [
                                                    146.042,
                                                    -130.646
                                                ]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: "Path 1",
                                    mn: "ADBE Vector Shape - Group",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.023529411764705882,
                                            0.4196078431372549,
                                            0.39215686274509803,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 60,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Vector",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.24
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.76
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            0
                                        ]
                                    },
                                    {
                                        t: 60,
                                        s: [
                                            100
                                        ]
                                    }
                                ],
                                ix: 1
                            },
                            e: {
                                a: 0,
                                k: 100,
                                ix: 2
                            },
                            o: {
                                a: 0,
                                k: 0,
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 1740,
                    st: -60,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 3,
                    ty: 4,
                    nm: "Vector 3",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                657.564,
                                631.968,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    ind: 0,
                                    ty: "sh",
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    40.328,
                                                    -33.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    33.84,
                                                    40.337
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -0.702,
                                                    -215.724
                                                ],
                                                [
                                                    100.133,
                                                    -95.53
                                                ],
                                                [
                                                    88.383,
                                                    38.79
                                                ],
                                                [
                                                    -122.436,
                                                    215.724
                                                ]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: "Path 1",
                                    mn: "ADBE Vector Shape - Group",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.023529411764705882,
                                            0.4196078431372549,
                                            0.39215686274509803,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 60,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Vector",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 0,
                                k: 0,
                                ix: 1
                            },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.48
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.26
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        t: 26,
                                        s: [
                                            100
                                        ]
                                    },
                                    {
                                        t: 49,
                                        s: [
                                            0
                                        ]
                                    }
                                ],
                                ix: 2
                            },
                            o: {
                                a: 0,
                                k: 0,
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 1766,
                    st: -34,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 4,
                    ty: 4,
                    nm: "Vector 4",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                373.021,
                                654.462,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    ind: 0,
                                    ty: "sh",
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    73.021,
                                                    -61.284
                                                ],
                                                [
                                                    -73.021,
                                                    61.284
                                                ]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: "Path 1",
                                    mn: "ADBE Vector Shape - Group",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.023529411764705882,
                                            0.4196078431372549,
                                            0.39215686274509803,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 60,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Vector",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 0,
                                k: 0,
                                ix: 1
                            },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.48
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.26
                                            ],
                                            y: [
                                                0.517
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            100
                                        ]
                                    },
                                    {
                                        t: 31,
                                        s: [
                                            0
                                        ]
                                    }
                                ],
                                ix: 2
                            },
                            o: {
                                a: 0,
                                k: 0,
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 1740,
                    st: -60,
                    bm: 0
                }
            ]
        },
        {
            id: "comp_1",
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: "Vector 5",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                554.282,
                                340.304,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    ind: 0,
                                    ty: "sh",
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    40.328,
                                                    -33.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -33.84,
                                                    -40.337
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    37.803,
                                                    130.304
                                                ],
                                                [
                                                    102.58,
                                                    75.939
                                                ],
                                                [
                                                    183.773,
                                                    7.796
                                                ],
                                                [
                                                    96.491,
                                                    -96.245
                                                ],
                                                [
                                                    -37.803,
                                                    -107.996
                                                ],
                                                [
                                                    -183.773,
                                                    14.512
                                                ]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: "Path 1",
                                    mn: "ADBE Vector Shape - Group",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.023529411764705882,
                                            0.4196078431372549,
                                            0.39215686274509803,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 60,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Vector",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.48
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.26
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        t: 35,
                                        s: [
                                            100
                                        ]
                                    },
                                    {
                                        t: 87,
                                        s: [
                                            0
                                        ]
                                    }
                                ],
                                ix: 1
                            },
                            e: {
                                a: 0,
                                k: 100,
                                ix: 2
                            },
                            o: {
                                a: 0,
                                k: 0,
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 35,
                    op: 1800,
                    st: 35,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 4,
                    nm: "Vector",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                446.042,
                                601.254,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    ind: 0,
                                    ty: "sh",
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -40.328,
                                                    33.846
                                                ],
                                                [
                                                    33.84,
                                                    40.337
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -40.328,
                                                    33.846
                                                ],
                                                [
                                                    -33.84,
                                                    -40.337
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    33.84,
                                                    40.337
                                                ],
                                                [
                                                    40.328,
                                                    -33.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -33.84,
                                                    -40.337
                                                ],
                                                [
                                                    40.328,
                                                    -33.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -146.042,
                                                    114.492
                                                ],
                                                [
                                                    -45.208,
                                                    234.686
                                                ],
                                                [
                                                    89.086,
                                                    246.438
                                                ],
                                                [
                                                    100.835,
                                                    112.118
                                                ],
                                                [
                                                    0,
                                                    -8.077
                                                ],
                                                [
                                                    -87.283,
                                                    -112.118
                                                ],
                                                [
                                                    -75.534,
                                                    -246.438
                                                ],
                                                [
                                                    58.759,
                                                    -234.686
                                                ],
                                                [
                                                    146.042,
                                                    -130.646
                                                ]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: "Path 1",
                                    mn: "ADBE Vector Shape - Group",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.023529411764705882,
                                            0.4196078431372549,
                                            0.39215686274509803,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 60,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Vector",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 0,
                                k: 0,
                                ix: 1
                            },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.24
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.76
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            0
                                        ]
                                    },
                                    {
                                        t: 60,
                                        s: [
                                            100
                                        ]
                                    }
                                ],
                                ix: 2
                            },
                            o: {
                                a: 0,
                                k: 0,
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 1800,
                    st: 0,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 3,
                    ty: 4,
                    nm: "Vector 3",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                657.564,
                                631.968,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    ind: 0,
                                    ty: "sh",
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    40.328,
                                                    -33.846
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    33.84,
                                                    40.337
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -0.702,
                                                    -215.724
                                                ],
                                                [
                                                    100.133,
                                                    -95.53
                                                ],
                                                [
                                                    88.383,
                                                    38.79
                                                ],
                                                [
                                                    -122.436,
                                                    215.724
                                                ]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: "Path 1",
                                    mn: "ADBE Vector Shape - Group",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.023529411764705882,
                                            0.4196078431372549,
                                            0.39215686274509803,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 60,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Vector",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.48
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.26
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        t: 26,
                                        s: [
                                            100
                                        ]
                                    },
                                    {
                                        t: 85,
                                        s: [
                                            0
                                        ]
                                    }
                                ],
                                ix: 1
                            },
                            e: {
                                a: 0,
                                k: 100,
                                ix: 2
                            },
                            o: {
                                a: 0,
                                k: 0,
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 26,
                    op: 1800,
                    st: 26,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 4,
                    ty: 4,
                    nm: "Vector 4",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                373.021,
                                654.462,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    ind: 0,
                                    ty: "sh",
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    73.021,
                                                    -61.284
                                                ],
                                                [
                                                    -73.021,
                                                    61.284
                                                ]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: "Path 1",
                                    mn: "ADBE Vector Shape - Group",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.023529411764705882,
                                            0.4196078431372549,
                                            0.39215686274509803,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 60,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Vector",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.74
                                            ],
                                            y: [
                                                0.508
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.52
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            100
                                        ]
                                    },
                                    {
                                        t: 30,
                                        s: [
                                            0
                                        ]
                                    }
                                ],
                                ix: 1
                            },
                            e: {
                                a: 0,
                                k: 100,
                                ix: 2
                            },
                            o: {
                                a: 0,
                                k: 0,
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 1800,
                    st: 0,
                    bm: 0
                }
            ]
        }
    ],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 0,
            nm: "S Draw 2 end",
            refId: "comp_0",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        360,
                        360.5,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        540,
                        540,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            w: 1080,
            h: 1080,
            ip: 97,
            op: 205,
            st: 97,
            bm: 0
        },
        {
            ddd: 0,
            ind: 2,
            ty: 0,
            nm: "S Draw 2 start",
            refId: "comp_1",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        360,
                        360.5,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        540,
                        540,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            w: 1080,
            h: 1080,
            ip: 10,
            op: 98,
            st: 10,
            bm: 0
        },
        {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "Vector",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 25,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        360,
                        360,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        0,
                        0,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -33.84,
                                            -40.337
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            40.328,
                                            -33.846
                                        ]
                                    ],
                                    o: [
                                        [
                                            40.328,
                                            -33.846
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -33.84,
                                            -40.337
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -169.491,
                                            -185.183
                                        ],
                                        [
                                            -35.198,
                                            -173.432
                                        ],
                                        [
                                            52.085,
                                            -69.391
                                        ],
                                        [
                                            116.862,
                                            -123.757
                                        ],
                                        [
                                            198.056,
                                            -191.9
                                        ],
                                        [
                                            110.773,
                                            -295.941
                                        ],
                                        [
                                            -23.521,
                                            -307.692
                                        ]
                                    ],
                                    c: true
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ind: 1,
                            ty: "sh",
                            ix: 2,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -40.328,
                                            33.846
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -33.84,
                                            -40.337
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -93.958,
                                            53.177
                                        ],
                                        [
                                            -181.241,
                                            -50.863
                                        ],
                                        [
                                            -169.491,
                                            -185.183
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 2",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ind: 2,
                            ty: "sh",
                            ix: 3,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -40.328,
                                            33.846
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            33.84,
                                            40.337
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -93.958,
                                            53.177
                                        ],
                                        [
                                            -240,
                                            175.746
                                        ],
                                        [
                                            -139.165,
                                            295.941
                                        ],
                                        [
                                            -4.872,
                                            307.692
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 3",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ind: 3,
                            ty: "sh",
                            ix: 4,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            40.328,
                                            -33.846
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            33.84,
                                            40.337
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -93.958,
                                            53.177
                                        ],
                                        [
                                            6.877,
                                            173.372
                                        ],
                                        [
                                            -4.872,
                                            307.692
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 4",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ind: 4,
                            ty: "sh",
                            ix: 5,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            40.328,
                                            -33.846
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            33.84,
                                            40.337
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            116.862,
                                            -123.757
                                        ],
                                        [
                                            217.697,
                                            -3.562
                                        ],
                                        [
                                            205.947,
                                            130.758
                                        ],
                                        [
                                            -4.872,
                                            307.692
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 5",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "mm",
                            mm: 1,
                            nm: "Merge Paths 1",
                            mn: "ADBE Vector Filter - Merge",
                            hd: false
                        },
                        {
                            ty: "st",
                            c: {
                                a: 0,
                                k: [
                                    0.023529411764705882,
                                    0.4196078431372549,
                                    0.39215686274509803,
                                    1
                                ],
                                ix: 3
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 60,
                                ix: 5
                            },
                            lc: 1,
                            lj: 2,
                            bm: 0,
                            nm: "Stroke 1",
                            mn: "ADBE Vector Graphic - Stroke",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Vector",
                    np: 7,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                }
            ],
            ip: 0,
            op: 1800,
            st: 0,
            bm: 0
        }
    ],
    markers: []
};

//# sourceMappingURL=loadingLogoAnimationGreen.js.map